import React from 'react';
import InputField from '../../../components/CustomFields/InputField';
import Dropdown from '../../../components/CustomFields/Dropdown';
import { academyLogger } from "utils/logger";

const PersonalInfo = ({ student, handleChange, handleChangeDynamicAttribute }) => {

    const formatPhoneNumber = (phoneNumber) => {
        const cleaned = phoneNumber.replace(/\D/g, ""); // Remove non-numeric characters
        if (cleaned.startsWith("91") && cleaned.length > 2) {
            return `+91 ${cleaned.slice(2, 7)} ${cleaned.slice(7)}`; // Format as "+91 97898 30424"
        }
        return cleaned; // Return unformatted number if conditions are not met
    };

    academyLogger.info(student.dob); // Log student.dob

    return (
        <section className="">
            <h2 className="text-lg font-semibold text-[#824296] text-center">Student Information
</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {/* First Name */}
                <InputField
                    id="firstName"
                    label="First Name *"
                    value={student.firstName}
                    onChange={(e) => handleChange('firstName', e.target.value)}
                //placeholder="Enter your first name"
                />

                {/* Last Name */}
                <InputField
                    id="lastName"
                    label="Last Name *"
                    value={student.lastName}
                    onChange={(e) => handleChange('lastName', e.target.value)}
                //placeholder="Enter your last name"
                />

                {/* Email */}
                <InputField
                    id="email"
                    label="Email *"
                    value={student.email}
                    onChange={(e) => handleChange('email', e.target.value)}
                    //placeholder="Enter your email"
                    type="email"
                />

                {/* Phone Number */}
                <InputField
                    id="phoneNumber"
                    label="Mobile Number *"
                    value={formatPhoneNumber(student.phoneNumber)}
                    onChange={(e) => handleChange("phoneNumber", e.target.value)}
                />

                {/* Gender */}
                <Dropdown
                    id="gender"
                    label="Gender *"
                    value={student.gender}
                    onChange={(e) => handleChange('gender', e.target.value)}
                    options={[
                        { label: "Male", value: "MALE" },
                        { label: "Female", value: "FEMALE" },
                    ]}
                    defaultOption="Select Gender *"
                />

                <InputField
                    id="dob"
                    label="Date of Birth *"
                    value={student.dob ? student.dob.split('T')[0] : ''}
                    onChange={(e) => handleChange('dob', e.target.value)}
                    type="date"
                />




                {/* Dynamic Attributes */}
                {student.dynamicAttributes
                    ?.map((attribute, originalIndex) => ({ attribute, originalIndex }))
                    .filter(({ attribute }) => attribute.name !== "How did you know about Velammal")
                    .map(({ attribute, originalIndex }) => (
                        <InputField
                            key={originalIndex}
                            id={`dynamicAttribute-${originalIndex}`}
                            label={attribute.name}
                            value={attribute.value}
                            onChange={(e) => handleChangeDynamicAttribute(originalIndex, e.target.value)}
                        />
                    ))}

            </div>
        </section>
    );
};

export default PersonalInfo;